import Icon from '../components/Icon.vue'

Icon.register({"battery-three-quarters":{"width":640,"height":512,"paths":[{"d":"M544 160V224H576V288H544V352H64V160H544M560 96H48C21.5 96 0 117.5 0 144V368C0 394.5 21.5 416 48 416H560C586.5 416 608 394.5 608 368V352H616C629.3 352 640 341.3 640 328V184C640 170.7 629.3 160 616 160H608V144C608 117.5 586.5 96 560 96zM416 192H96V320H416V192z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/battery-three-quarters.js
// module id = EYYE
// module chunks = 0